import { Router } from '@angular/router';
import { AppService } from './app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(_service, spinnerService, router) {
        this._service = _service;
        this.spinnerService = spinnerService;
        this.router = router;
        this.registerData = { username: "", password: "", password1: "", recaptchaResponse: "" };
        this.consentChecked = false;
        this.ACTION = 'signup';
        this.captchaRetries = 0;
        this.maxRetries = 50; // 10 secondi (50 * 200ms)
        this.typeSelected = 'ball-fussion';
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Sottoscrizione per rigenerare il captcha quando c'è un errore
        this._service.regenerateCaptcha$.subscribe(function () {
            _this.regenerateCaptcha();
        });
        // Aspetta che il DOM sia completamente caricato
        if (document.readyState === 'complete') {
            this.requestRecaptchaV3Token();
        }
        else {
            window.addEventListener('load', function () {
                setTimeout(function () { return _this.requestRecaptchaV3Token(); }, 500);
            });
        }
    };
    RegisterComponent.prototype.requestRecaptchaV3Token = function () {
        var _this = this;
        // Verifica se window.grecaptcha esiste
        var globalgrecaptcha = window.grecaptcha;
        if (typeof globalgrecaptcha === 'undefined' || !globalgrecaptcha || !globalgrecaptcha.enterprise) {
            this.captchaRetries++;
            if (this.captchaRetries >= this.maxRetries) {
                console.error('reCAPTCHA script failed to load after ' + this.maxRetries + ' retries');
                this.registerData.recaptchaResponse = 'captcha-load-failed';
                return;
            }
            console.log('grecaptcha not loaded yet, retrying... (' + this.captchaRetries + '/' + this.maxRetries + ')');
            setTimeout(function () { return _this.requestRecaptchaV3Token(); }, 200);
            return;
        }
        try {
            globalgrecaptcha.enterprise.ready(function () {
                globalgrecaptcha.enterprise.execute(environment.captcha_key, { action: _this.ACTION })
                    .then(function (token) {
                    _this.registerData.recaptchaResponse = token;
                    console.log('reCAPTCHA v3 token:', token);
                })
                    .catch(function (error) {
                    console.error('reCAPTCHA execute error:', error);
                    _this.registerData.recaptchaResponse = 'captcha-execute-failed';
                });
            });
        }
        catch (error) {
            console.error('reCAPTCHA ready error:', error);
            this.registerData.recaptchaResponse = 'captcha-ready-failed';
        }
    };
    RegisterComponent.prototype.regenerateCaptcha = function () {
        // Reset dei retry e rigenera il token
        this.captchaRetries = 0;
        console.log('Regenerating captcha token...');
        this.requestRecaptchaV3Token();
    };
    RegisterComponent.prototype.showSpinner = function () {
        this.spinnerService.show();
    };
    RegisterComponent.prototype.login = function () {
        this.router.navigate(['/prelogin']);
    };
    RegisterComponent.prototype.register = function () {
        this.showSpinner();
        if (this.registerData.password !== this.registerData.password1) {
            alert("Pin not the same");
            this.registerData.password = this.registerData.password1 = "";
            return;
        }
        if (this.registerData.username.indexOf('+') != -1) {
            this.registerData.username = this.registerData.username.substring(1);
        }
        if (this.registerData.username.substring(0, 2) == "00") {
            this.registerData.username = this.registerData.username.substring(2);
        }
        // Rimuove tutti i caratteri non numerici da username
        this.registerData.username = this.registerData.username.replace(/\D/g, '');
        this._service.register(this.registerData);
    };
    return RegisterComponent;
}());
export { RegisterComponent };
